const MAC_HEX_REGEX = /^[0-9A-Fa-f]{12}$/;

export const isValidMacAddress = (mac = "") => MAC_HEX_REGEX.test(mac?.trim?.() ?? "");

export const isValidMacSerial = (serial = "") => MAC_HEX_REGEX.test(serial?.trim?.() ?? "");

export const calculateMacSerial = (mac = "") => {
  if (!isValidMacAddress(mac)) return "";
  return mac.trim().toUpperCase().match(/.{2}/g).reverse().join("");
};

export const calculateSerialMac = (serial = "") => {
  if (!isValidMacSerial(serial)) return "";
  return serial.trim().toUpperCase().match(/.{2}/g).reverse().join("");
};
